export default __webpack_public_path__ + "static/novo-amor-ea90815d461a361c1109f7ec255b3f70.mp3";